import React from "react";

export default function UrlHighlighter({
  method,
  link,
}: {
  method?: string;
  link: string;
}) {
  const indexOfSlash = link.indexOf("//");
  const protocol = link.substring(0, indexOfSlash);
  const url = link.substring(indexOfSlash, link.length);

  return (
    <div className="text-sm">
      {method && <span className="mr-2">{method}</span>}
      <span>{protocol}</span>
      <span className="text-promGreen">{url}</span>
    </div>
  );
}
